export default __webpack_public_path__ + "static/media/DashboardActive.af7f7d84.svg";